import React from "react";
import { Routes, Route } from "react-router-dom";
import BlogPage from "./components/BlogPage/BlogPage";
// import CaseStudyPage from "./components/CaseStudy/CaseStudyPage";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage/HomePage";
import Nav from "./components/Nav";
import ServicesPage from "./components/Services/ServicesPage";
import ContactUs from "./components/ContactUs/ContactUs";
import Modal from "react-modal";
import ConsultForm from "./components/common/ConsultForm";
// import DetailedCaseStudyPage from "./components/CaseStudy/DetailedCaseStudyPage";
import AboutPage from "./components/AboutPage/AboutPage";
import { ToastContainer } from "react-toastify";
import { DataProvider } from "./context/DataContext";
import DetailedBlogPage from "./components/BlogPage/DetailedBlogPage";

function App() {
  const [isOpen, setIsOpen] = React.useState(false);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      height: "80vh",
      width: "80vw",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "0px",
      display: "flex",
      justifyContent: "center",
    },
  };

  return (
    <>
      <Nav />
      <DataProvider>
        <Routes>
          <Route path="/" element={<HomePage setIsOpen={setIsOpen} />} />
          <Route
            path="/services"
            element={<ServicesPage setIsOpen={setIsOpen} />}
          />
          {/* <Route */}
          {/*   path="/case-study" */}
          {/*   element={<CaseStudyPage setIsOpen={setIsOpen} />} */}
          {/* /> */}
          {/* <Route */}
          {/*   path="/case-study/:slug" */}
          {/*   element={<DetailedCaseStudyPage setIsOpen={setIsOpen} />} */}
          {/* /> */}
          <Route
            path="/contact-us"
            element={<ContactUs setIsOpen={setIsOpen} />}
          />
          <Route path="/blogs" element={<BlogPage setIsOpen={setIsOpen} />} />
          <Route
            path="/blog/:slug"
            element={<DetailedBlogPage setIsOpen={setIsOpen} />}
          />
          <Route path="/about" element={<AboutPage setIsOpen={setIsOpen} />} />
        </Routes>
        <Modal
          style={customStyles}
          isOpen={isOpen}
          onRequestClose={() => setIsOpen(false)}
        >
          <ConsultForm setIsOpen={setIsOpen} />
        </Modal>

        <Footer />
      </DataProvider>
      <ToastContainer />
    </>
  );
}

export default App;
